@if (!site.sitePlanFullWidth || (site.sitePlanFullWidth && !site.sitePlanVisible)) {
  <table #tablePlaceholder class="siteTable__placeholder">
    <div class="siteTable__placeholder-header-item">&nbsp;</div>
    @for (placeholder of placeholders; let index = $index; track index) {
      <tr class="siteTable__placeholder--row">
        <div class="siteTable__placeholder--cell">
          <div class="siteTable__placeholder-item">&nbsp;</div>
        </div>
      </tr>
    }
  </table>
}

<div class="sitePlan__placeholder">
  @if (site.sitePlanVisible) {
    <div
      #sitePlanPlaceholder
      [ngStyle]="{ 'width.%': ppPlanWidth }"
      class="sitePlan__placeholder-content"
    >
      <img [src]="EIconPath.PLACEHOLDER_MAP" alt="" />
    </div>
  }
</div>
